import { message } from 'ant-design-vue'

const reloadKey = 'route-chunk-reload-at'

export function handleRouteLoadError(error: unknown, to: { fullPath: string }): void {
  const text = error instanceof Error ? error.message : String(error)
  if (
    !/Failed to fetch dynamically imported module|Importing a module script failed|Failed to load module script|Unable to preload CSS|Loading chunk .* failed/i.test(
      text,
    )
  )
    return

  if (!navigator.onLine) {
    message.error('网络已断开，请恢复网络后重新打开页面')
    return
  }

  try {
    const lastReload = sessionStorage.getItem(reloadKey)
    if (lastReload && Date.now() - Number(lastReload) < 60_000) {
      message.error('页面资源加载失败，请稍后刷新；若仍失败，请联系管理员检查部署文件')
      return
    }
    sessionStorage.setItem(reloadKey, String(Date.now()))
  } catch {
    message.error('页面资源已更新或加载失败，请手动刷新页面')
    return
  }

  // 保留目标路由，整页刷新以获取最新入口及资源文件。
  window.history.replaceState(
    null,
    '',
    `${window.location.pathname}${window.location.search}#${to.fullPath}`,
  )
  window.location.reload()
}
